import React from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

interface FilterHeaderProps {
  onReset: () => void;
  onClose?: () => void;
}

const FilterHeader: React.FC<FilterHeaderProps> = ({ onReset, onClose }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #f0f0f0",
        paddingBottom: "5px",
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: "20px",
          fontWeight: 700,
          color: "#0f172a",
        }}
      >
        Filter
      </h3>
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <Button
          type="text"
          onClick={onReset}
          style={{
            color: "#00a3d9",
            fontWeight: 600,
            fontSize: "14px",
            padding: 0,
          }}
        >
          Reset
        </Button>
        <CloseOutlined
          onClick={onClose}
          style={{
            fontSize: "18px",
            color: "#64748b",
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );
};

export default FilterHeader;
